export const cashMetaFields = [
    {
        name: `Account`,
        field: `accountID`,
        check: `required`,
    },
    {
        name: `P mode`,
        field: `paymentModeID`,
        check: `required`,
    },
    {
        name: `Amt`,
        field: `totalCashAmount`,
        check: `greatorThanZero`,
    },
];export const mpesaMetaFields = [
    {
        name: `Phone Number`,
        field: `phonenumber`,
        check: `required`,
    },
    {
        name: 'Phone Number',
        field: 'phonenumber',
        check: 'min',
        value: 8
    },
    {
        name: `Amt`,
        field: `amount`,
        check: `greatorThanZero`,
    },
];

export const bankPaymentMetaFields = [
    {
        name: `Account`,
        field: `accountID`,
        check: `required`,
    },
    {
        name: `Payment mode`,
        field: `paymentModeID`,
        check: `required`,
    },
    {
        name: `Ref`,
        field: `bankRef`,
        check: `required`,
    },
    {
        name: `Amt`,
        field: `totalBankAmount`,
        check: `required`,
    },
    {
        name: `Date`,
        field: `bankPayDate`,
        check: `required`,
    },
];

export const weiverMetaFields = [
    {
        name: `Reason`,
        field: `reason`,
        check: `required`,
    },
    {
        name: `Ref`,
        field: `ref`,
        check: `required`,
    },
    {
        name: `Amt`,
        field: `weiverAmount`,
        check: `greatorThanZero`,
    },
];